import React, { useState } from "react"
import { Formik } from "formik"
import * as R from "ramda"
import { SketchPicker } from "react-color"

import {
  Pane,
  Heading,
  Text,
  Select,
  Option,
  Icon,
  Spinner,
  UnorderedList,
  ListItem,
  RadioGroup,
  Popover,
  Dialog,
  Checkbox,
  Strong,
  IconButton,
  FilePicker,
  FormField,
  TextInputField,
  Button,
  Link,
  Alert,
} from "evergreen-ui"

import ImagePicker from "../../components/ImagePicker"

import logoWhiteAndroid from "./logo-white-android.svg"
import menuWhiteAndroid from "./menu-white-android.svg"
import backWhiteAndroid from "./back-white-android.svg"
import actionLiveWhiteAndroid from "./action-live-white-android.svg"
import menuWhiteIos from "./menu-white-ios.svg"
import logoWhiteIos from "./logo-white-ios.svg"
import backWhiteIos from "./back-white-ios.svg"
import actionLiveWhiteIos from "./action-live-white-ios.svg"

const Container = ({ label, children }) => (
  <Pane margin={10}>
    <Text>{label}</Text>
    <Pane>{children}</Pane>
  </Pane>
)

const NavBar = ({
  deviceWidth,
  navBtn,
  logo,
  title,
  actions,
  backgroundColor,
  error,
  titleSafeZone,
  device,
  menuType,
}) => (
  <Pane display="flex" flexDirection="column" width={deviceWidth}>
    <Pane
      border
      width={deviceWidth}
      height={device === "android" ? 56 + 2 : 44 + 2}
      backgroundColor={error ? "#ccc" : backgroundColor}
      paddingTop={device === "android" ? 6 : 0}
    >
      {error ? (
        <Text margin={10}>Error - Check your configuration settings</Text>
      ) : (
        <Pane
          display="flex"
          justifyContent={
            menuType === "leftSided" ? "flex-start" : "space-between"
          }
        >
          <Pane flex={menuType === "leftSided" ? "none" : 1}>{navBtn}</Pane>
          <Pane flex={menuType === "leftSided" ? 1 : "none"}>
            {title ? <Text>{title}</Text> : logo}
          </Pane>
          <Pane
            flex={menuType === "leftSided" ? "none" : 1}
            display="flex"
            flexDirection="row-reverse"
          >
            {actions && actions.map(action => action)}
          </Pane>
        </Pane>
      )}
    </Pane>
  </Pane>
)

const validateHeight = height => (key, values, errors) => {
  if (!R.isEmpty(values[key]) && values[key].height !== height) {
    errors[key] = `Asset's height must be ${height}px`
  }
}

const validate132Height = validateHeight(132)
const validate168Height = validateHeight(168)

export default function() {
  return (
    <Pane>
      <Formik
        initialValues={{
          menuIcon_ios: {},
          backIcon_ios: {},
          logo_ios: {},
          action1_ios: {},
          action2_ios: {},
          action3_ios: {},
          menuIcon_android: {},
          backIcon_android: {},
          logo_android: {},
          action1_android: {},
          action2_android: {},
          action3_android: {},
          backgroundColor: "#cccccc",
          menuType: "centered",
          preset: "blank",
        }}
        validate={values => {
          let errors = {}
          validate132Height("menuIcon_ios", values, errors)
          validate132Height("backIcon_ios", values, errors)
          validate132Height("logo_ios", values, errors)
          validate132Height("action1_ios", values, errors)
          validate132Height("action2_ios", values, errors)
          validate132Height("action3_ios", values, errors)

          validate168Height("menuIcon_android", values, errors)
          validate168Height("backIcon_android", values, errors)
          validate168Height("logo_android", values, errors)
          validate168Height("action1_android", values, errors)
          validate168Height("action2_android", values, errors)
          validate168Height("action3_android", values, errors)
          const MIN_SUPPORTED_WIDTH = 320
          const RES_MULTIPLIER = 3
          const IOS_HEIGHT = 44
          const ANDROID_HEIGHT = 56

          const widthsMap = R.mapObjIndexed(value =>
            value.width ? value.width : 0
          )(values)

          console.log({ widthsMap })

          if (values.menuType === "centered") {
            if (
              widthsMap.logo_ios / 2 +
                widthsMap.action1_ios +
                widthsMap.action2_ios +
                widthsMap.action3_ios >
              (MIN_SUPPORTED_WIDTH * RES_MULTIPLIER) / 2
            ) {
              errors.rightSideIosWidth = true
            }

            if (
              widthsMap.logo_ios / 2 +
                (widthsMap.menuIcon_ios > widthsMap.backIcon_ios
                  ? widthsMap.menuIcon_ios
                  : widthsMap.backIcon_ios) >
              (MIN_SUPPORTED_WIDTH * RES_MULTIPLIER) / 2
            ) {
              errors.leftSideIosWidth = true
            }

            if (
              widthsMap.logo_android / 2 +
                widthsMap.action1_android +
                widthsMap.action2_android +
                widthsMap.action3_android >
              (MIN_SUPPORTED_WIDTH * RES_MULTIPLIER) / 2
            ) {
              errors.rightSideAndroidWidth = true
            }

            if (
              widthsMap.logo_android / 2 +
                (widthsMap.menuIcon_android > widthsMap.backIcon_android
                  ? widthsMap.menuIcon_android
                  : widthsMap.backIcon_android) >
              (MIN_SUPPORTED_WIDTH * RES_MULTIPLIER) / 2
            ) {
              console.log("***")

              errors.leftSideAndroidWidth = true
            }
          }
          console.log({ errors })

          return errors
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          setStatus,
          setFieldTouched,
        }) => {
          return (
            <Pane>
              <Pane display="flex">
                <Pane
                  width={300}
                  backgroundColor="#f5f6f6"
                  padding={10}
                  border
                  height="100vh"
                  overflow="auto"
                  r
                >
                  <Heading marginBottom={10}>Configure Menu</Heading>
                  <Pane marginLeft={-10} marginRight={-10} marginBottom={10}>
                    {errors.rightSideIosWidth && (
                      <Alert
                        intent="danger"
                        title="The sum of the widths of the iOS logo & the action assets exceeds the maximum allowed size"
                      />
                    )}
                    {errors.rightSideAndroidWidth && (
                      <Alert
                        intent="danger"
                        title="The sum of the widths of the Android logo & the action assets exceeds the maximum allowed size"
                      />
                    )}
                    {errors.leftSideIosWidth && (
                      <Alert
                        intent="danger"
                        title="The sum of the widths of the iOS logo & the nav icons asset exceeds the maximum allowed size"
                      />
                    )}
                    {errors.leftSideAndroidWidth && (
                      <Alert
                        intent="danger"
                        title="The sum of the widths of the Android logo & the nav icons asset exceeds the maximum allowed size"
                      />
                    )}
                  </Pane>
                  <FormField label="Starting Point Preset" marginBottom={10}>
                    <Select
                      value={values.preset}
                      onChange={e => {
                        setFieldValue("preset", e.target.value)
                        switch (e.target.value) {
                          case "blank":
                            R.forEachObjIndexed((value, key) =>
                              setFieldValue(key, value)
                            )({
                              menuIcon_ios: {},
                              backIcon_ios: {},
                              logo_ios: {},
                              action1_ios: {},
                              action2_ios: {},
                              action3_ios: {},
                              menuIcon_android: {},
                              backIcon_android: {},
                              logo_android: {},
                              action1_android: {},
                              action2_android: {},
                              action3_android: {},
                              backgroundColor: "#cccccc",
                              menuType: "centered",
                            })
                            break
                          case "materialDesign":
                            R.forEachObjIndexed((value, key) =>
                              setFieldValue(key, value)
                            )({
                              menuIcon_ios: {
                                thumb: menuWhiteIos,
                                width: 114,
                                height: 132,
                              },
                              backIcon_ios: {
                                thumb: backWhiteIos,
                                width: 114,
                                height: 132,
                              },
                              logo_ios: {
                                thumb: logoWhiteIos,
                                width: 302,
                                height: 132,
                              },
                              action1_ios: {
                                thumb: actionLiveWhiteIos,
                                width: 108,
                                height: 132,
                              },
                              action2_ios: {},
                              action3_ios: {},
                              menuIcon_android: {
                                thumb: menuWhiteAndroid,
                                width: 116,
                                height: 168,
                              },
                              backIcon_android: {
                                thumb: backWhiteAndroid,
                                width: 116,
                                height: 168,
                              },
                              logo_android: {
                                thumb: logoWhiteAndroid,
                                width: 304,
                                height: 168,
                              },
                              action1_android: {
                                thumb: actionLiveWhiteAndroid,
                                width: 108,
                                height: 168,
                              },
                              action2_android: {},
                              action3_android: {},
                              backgroundColor: "#14332D",
                              menuType: "leftSided",
                            })
                            break

                          default:
                            break
                        }
                      }}
                    >
                      <option value="blank" checked>
                        Blank
                      </option>
                      <option value="materialDesign">Material Design</option>
                    </Select>
                  </FormField>

                  <FormField label="Menu Type" marginBottom={10}>
                    <Select
                      value={values.menuType}
                      onChange={e => {
                        console.log(e.target.value)
                        setFieldValue("menuType", e.target.value)
                      }}
                    >
                      <option value="centered" checked>
                        Centered
                      </option>
                      <option value="leftSided">Left Sided</option>
                    </Select>
                  </FormField>

                  <FormField label="Background Color" marginBottom={10}>
                    <Popover
                      content={
                        <SketchPicker
                          color={values.backgroundColor}
                          onChangeComplete={color => {
                            setFieldValue("backgroundColor", color.hex)
                          }}
                        />
                      }
                    >
                      <Button>
                        <Pane
                          backgroundColor={values.backgroundColor}
                          width={40}
                          height={20}
                          border
                        />
                      </Button>
                    </Popover>
                  </FormField>
                  {R.map(({ label, description, options, key }) => (
                    <ImagePicker
                      backgroundColor={values.backgroundColor}
                      label={label}
                      validationMessage={errors[key]}
                      options={options}
                      description={description}
                      value={values[key]}
                      onChange={data => {
                        setFieldValue(key, data)
                      }}
                    />
                  ))([
                    {
                      label: "Menu Icon",
                      description:
                        "A PNG or SVG file with the height of 132px.",
                      options: [{ thumb: menuWhiteIos, label: "White Menu" }],
                      key: "menuIcon_ios",
                    },
                    {
                      label: "Back Icon",
                      description:
                        "A PNG or SVG file with the height of 132px. It's recommended that the `Back Icon` width will have the same width as the `Menu Icon`.",
                      options: [{ thumb: backWhiteIos, label: "White Back" }],
                      key: "backIcon_ios",
                    },
                    {
                      label: "Logo",
                      description:
                        "A PNG or SVG file with the height of 132px.",
                      options: [{ thumb: logoWhiteIos, label: "White Logo" }],
                      key: "logo_ios",
                    },
                  ])}

                  <ImagePicker
                    label="Action 1"
                    backgroundColor={values.backgroundColor}
                    options={[
                      { thumb: actionLiveWhiteIos, label: "Action Live" },
                    ]}
                    description="A PNG or SVG file with the height of 132px"
                    value={values.action1_ios}
                    onChange={data => {
                      setFieldValue("action1_ios", data)
                    }}
                  />

                  <ImagePicker
                    label="Action 2"
                    backgroundColor={values.backgroundColor}
                    options={[
                      { thumb: actionLiveWhiteIos, label: "Action Live" },
                    ]}
                    description="A PNG or SVG file with the height of 132px"
                    value={values.action2_ios}
                    onChange={data => {
                      setFieldValue("action2_ios", data)
                    }}
                  />
                  <ImagePicker
                    backgroundColor={values.backgroundColor}
                    label="Action 3"
                    options={[
                      { thumb: actionLiveWhiteIos, label: "Action Live" },
                    ]}
                    description="A PNG or SVG file with the height of 132px"
                    value={values.action3_ios}
                    onChange={data => {
                      setFieldValue("action3_ios", data)
                    }}
                  />

                  {/* Android */}
                </Pane>
                <Pane flex={1} border>
                  <Heading margin={10}>iOS</Heading>
                  {R.map(({ deviceName, deviceWidth }) => (
                    <Pane display="flex" key={`${deviceName}-${deviceWidth}`}>
                      {R.map(({ label, navBtn, width }) => (
                        <Container label={label}>
                          <NavBar
                            menuType={values.menuType}
                            backgroundColor={values.backgroundColor}
                            error={!R.isEmpty(errors)}
                            deviceWidth={width}
                            navBtn={
                              <img src={values[navBtn].thumb} height={44} />
                            }
                            logo={
                              <img src={values["logo_ios"].thumb} height={44} />
                            }
                            actions={[
                              <img
                                src={values["action1_ios"].thumb}
                                height={44}
                              />,
                              <img
                                src={values["action2_ios"].thumb}
                                height={44}
                              />,
                              <img
                                src={values["action3_ios"].thumb}
                                height={44}
                              />,
                            ]}
                          />
                        </Container>
                      ))([
                        {
                          label: `${deviceName} (${deviceWidth}x44 points)`,
                          navBtn: "menuIcon_ios",
                          width: deviceWidth,
                        },
                        {
                          label: `${deviceName} - inner screens (${deviceWidth}x44 points)`,
                          navBtn: "backIcon_ios",
                          width: deviceWidth,
                        },
                      ])}
                    </Pane>
                  ))([
                    { deviceName: "iPhone SE", deviceWidth: 320 },
                    { deviceName: "iPhone 6, 7, 8, X", deviceWidth: 375 },
                    { deviceName: "iPhone 7 Plus, 8 Plus", deviceWidth: 414 },
                  ])}
                  <Heading margin={10}>Android</Heading>

                  {R.map(({ deviceName, deviceWidth, device }) => (
                    <Pane display="flex">
                      {R.map(({ label, navBtn, width }) => (
                        <Container label={label}>
                          <NavBar
                            menuType={values.menuType}
                            device={device}
                            backgroundColor={values.backgroundColor}
                            error={!R.isEmpty(errors)}
                            deviceWidth={width}
                            navBtn={
                              <img src={values[navBtn].thumb} height={44} />
                            }
                            logo={
                              <img src={values["logo_ios"].thumb} height={44} />
                            }
                            actions={[
                              <img
                                src={values["action1_ios"].thumb}
                                height={44}
                              />,
                              <img
                                src={values["action2_ios"].thumb}
                                height={44}
                              />,
                              <img
                                src={values["action3_ios"].thumb}
                                height={44}
                              />,
                            ]}
                          />
                        </Container>
                      ))([
                        {
                          label: `${deviceName} (${deviceWidth}x56 dp)`,
                          navBtn: "menuIcon_ios",
                          width: deviceWidth,
                        },
                        {
                          label: `${deviceName} - inner screens (${deviceWidth}x56 dp)`,
                          navBtn: "backIcon_ios",
                          width: deviceWidth,
                        },
                      ])}
                    </Pane>
                  ))([
                    {
                      deviceName: "Android typical phone screen",
                      deviceWidth: 320,
                      device: "android",
                    },
                    {
                      deviceName: "Android large phone screen",
                      deviceWidth: 480,
                      device: "android",
                    },
                  ])}
                </Pane>
              </Pane>
            </Pane>
          )
        }}
      </Formik>
    </Pane>
  )
}

/*

Reference

https://developer.android.com/guide/practices/ui_guidelines/icon_design_menu
https://developer.apple.com/design/human-interface-guidelines/ios/bars/navigation-bars/
https://material.io/design/components/app-bars-top.html#specs
https://developer.apple.com/library/archive/documentation/DeviceInformation/Reference/iOSDeviceCompatibility/Displays/Displays.html


Here's how other smallest width values correspond to typical screen sizes:

320dp: a typical phone screen (240x320 ldpi, 320x480 mdpi, 480x800 hdpi, etc).
480dp: a large phone screen ~5" (480x800 mdpi).
600dp: a 7” tablet (600x1024 mdpi).
720dp: a 10” tablet (720x1280 mdpi, 800x1280 mdpi, etc).

(Taken from https://developer.android.com/training/multiscreen/screensizes)


TODOS

- Left sided validation

- Use menu background for thumbnail bg

- Gradient background

- Does iOS supports SVG
*/
